import { useEffect, useRef, useState } from 'react'

import { ClearSocketMessageHandler, ConnectWebSocketForScreen, DisconnectWebSocket, GetGenderMode, SetSocketMessageHandler } from './../../utilities/BL/Zones'

import { Questions } from './Sections/Questions'
import { Results } from './Sections/Results'
import { Wait } from './Sections/Wait'
import { Welcome } from './Sections/Welcome'
import { Colors } from './Sections/Colors'
import { Start } from './Sections/Start'
import { Thanks } from './Sections/Thanks'
import { Lottery } from './Sections/Lottery'
import { GoalScreen } from './Sections/GoalScreen'
import { GoalScreenV2 } from './Sections/GoalScreenV2'
import { GoalScreenV2_Caminadora } from './Sections/GoalScreenV2_Caminadora'
import { Versus } from './Sections/Goal/Versus'
import { Riddle } from './Sections/Riddle'
import { RiddleCover } from './Sections/Riddle/RiddleCover'
import { RiddlePodium } from './Sections/Riddle/RiddlePodium'
import { QuizzWithImageAndOptions } from './Sections/QuizzWithImageAndOptions'
import { FrontPage } from './Sections/QuizzWithImageAndOptions/FrontPage'
import { FrontPage as RiddleFrontPage } from './Sections/Riddle/FrontPage'

import Balloons from './Sections/Balloons'
import { BalloonsFrontPage } from './Sections/Balloons/FrontPages/BalloonsFrontPage'
import { Rojito as RojitoBrandFrontPage } from './Sections/Balloons/FrontPages/Brands/Rojito'
import { Rojito as RojitoBrandBalloons } from './Sections/Balloons/Brands/RojitoDrinks'

import { Noisemeter } from './../Overlays/Noisemeter'
import { Noisemeter as FrontPageNoisemeter } from './../Overlays/Overlays/Noisemeter'
import { NoisemeterV2 } from './../Overlays/NoisemeterV2'
import { NoisemeterV2 as FrontPageNoisemeterV2 } from './../Overlays/Overlays/NoisemeterV2'
import { SelfieFan } from './Sections/SelfieFan'
import { QRSelfieFan } from './Sections/QRSelfieFan'
import { QRMessages } from './Sections/QRMessages'
import { SelfieFanIA } from './Sections/SelfieFanIA'
import { QRPluckingRooster } from './Sections/QRPluckingRooster'
import { RankingPluckingRooster } from './Sections/RankingPluckingRooster'
import { FrontPageLuchoFest } from './Sections/LuchoFest/FrontPageLuchoFest'
import { LuchoFest } from './Sections/LuchoFest'
import { FrontPage as FrontPagePicnic } from './Sections/Picnic/FrontPagePicnic'
import { Picnic } from './Sections/Picnic'
import { FrontPageRunToGoal } from './Sections/Goal/FrontPageRunToGoal'
import { FrontPageRunToGoal as FrontPageRunToGoalDaikin } from './Sections/Goal/Brands/Daikin/FrontPageRunToGoal'
import { Tacos } from './Sections/Tacos'
import { FrontPageTacos } from './Sections/Tacos/FrontPageTacos'
import { Package } from './Sections/Package'
import { FrontPagePackage } from './Sections/Package/FrontPagePackage'

import { SoupSimulator } from './Sections/Soup/Brands/SoupSimulator'
import { BriefcaseScreen } from './Sections/BriefcaseScreen'
import { FrontPageBriefcase } from './Sections/Briefcase/FrontPageBriefcase'

import { CatchTheBall } from './Sections/CatchTheBall'
import { SlotMachine } from './Sections/SlotMachine'
import { Roulette } from './Sections/Roulette'

import { Voting } from './Sections/Voting'
import { FrontPageSequence } from './Sections/Sequence/FrontPageSequence'
import { SequenceScreen } from './Sections/SequenceScreen'
import { FrontPageRollers } from './Sections/Rollers/FrontPageRollers'
import { RollersScreen } from './Sections/RollersScreen'
import { DinosaurFrontPage } from './Sections/Dinosaur/DinosaurFrontPage'
import { DinosaurScreen } from './Sections/Dinosaur/DinosaurScreen'
import { FarmeandoAuraCover } from './Sections/FarmeandoAura/FarmeandoAuraCover'
import { FarmeandoAuraGame } from './Sections/FarmeandoAura/FarmeandoAuraGame'
import { BuzzerBattleCover } from './Sections/BuzzerBattle/BuzzerBattleCover'
import { BuzzerBattleGame } from './Sections/BuzzerBattle/BuzzerBattleGame'
import { ScratcherCover } from './Sections/Scratcher/ScratcherCover'
import { ScratcherGame } from './Sections/Scratcher/ScratcherGame'
import { QuickReactionCover } from './Sections/QuickReaction/QuickReactionCover'
import { QuickReactionGame } from './Sections/QuickReaction/QuickReactionGame'
import { PlaylistScreen } from './Sections/PlaylistScreen'
import { TugOfWarCover } from './Sections/TugOfWar/TugOfWarCover'
import { TugOfWarGame } from './Sections/TugOfWar/TugOfWarGame'
import { MemoryCover, MemoryGame } from './Sections/Memory'
import { OptimoOpticasCover } from './Sections/OptimoOpticasCover'
import { CronometerCover, CronometerGame } from './Sections/Cronometer'
import { QRMemoryIndividual } from './Sections/QRMemoryIndividual'




const Screen = () => {
    const [question, setQuestion] = useState(null)
    const [results, setResults] = useState(null)
    const [lottery, setLottery] = useState(null)
    const [connectionStatus, setConnectionStatus] = useState('idle')
    const [toastMessage, setToastMessage] = useState('')

    const [activeComponent, setActiveComponent] = useState(null)

    const [currentMatchId, setCurrentMatchId] = useState(null);
    const [phase, setPhase] = useState('idle');
    const [timing, setTiming] = useState({ startAt: null, endsAt: null });

    const [isActiveWomensMode, setIsActiveWomensMode] = useState(null)

    const countdownTimerRef = useRef(null)
    const [balloonsUI, setBalloonsUI] = useState({
        uiStatus: 'Idle',
        countdownUntil: null
    })

    const [tacoMatchState, setTacoMatchState] = useState(null);

    const [catchMatchState, setCatchMatchState] = useState(null);

    const [slotPayload, setSlotPayload] = useState(null)
    const [roulettePayload, setRoulettePayload] = useState(null)
    const [sequencePayload, setSequencePayload] = useState(null)
    const [rollersPayload, setRollersPayload] = useState(null)
    const [dinosaurPayload, setDinosaurPayload] = useState(null)
    const [auraPayload, setAuraPayload] = useState(null)
    const [buzzerPayload, setBuzzerPayload] = useState(null)
    const [scratcherPayload, setScratcherPayload] = useState(null)
    const [quickReactionPayload, setQuickReactionPayload] = useState(null)
    const [playlistPayload, setPlaylistPayload] = useState(null)
    const [tugOfWarPayload, setTugOfWarPayload] = useState(null)
    const [memoryPayload, setMemoryPayload] = useState(null)
    const [optimoOpticasPayload, setOptimoOpticasPayload] = useState(null)
    const [cronometerPayload, setCronometerPayload] = useState(null)
    const [memoryIndividualPayload, setMemoryIndividualPayload] = useState(null)




    const showToast = (msg) => {
        setToastMessage(msg)
        setTimeout(() => setToastMessage(''), 3000)
    }

    // // ENRUTADOR INTELIGENTE (Detecta si es V1 o V2)
    // const routeGoalByState = (state, matchData) => {
    //     if (matchData && matchData.elapsedMilliseconds !== undefined) {
    //         return (state === 'Running' || state === 'Finished') ? 5.2 : 5;
    //     }
    //     return (state === 'Running' || state === 'Finished') ? 5.1 : 5;
    // }

    // // ENRUTADOR INTELIGENTE (Detecta si es V1 o V2)
    // const routeGoalByState = (state, matchData) => {
    //     // Verificamos si es V2
    //     if (matchData && matchData.elapsedMilliseconds !== undefined) {
    //         // Si está en espera, mostramos la Portada Animada (5.3)
    //         if (state === 'Waiting' || state === 'Idle') return 5.3;
    //         // Si está corriendo o finalizó, mostramos el juego y la animación de gol (5.2)
    //         return 5.2;
    //     }

    //     // Si no, es la V1 original (Se mantiene intacta)
    //     return (state === 'Running' || state === 'Finished') ? 5.1 : 5;
    // }

    // // ENRUTADOR INTELIGENTE (A prueba de fallos)
    // const routeGoalByState = (state, matchData) => {
    //     // 1. Si el juego está en espera (recién entramos a la sección o reiniciamos),
    //     // SIEMPRE mostramos la Portada Animada Nueva, cortando de raíz cualquier error.
    //     if (state === 'Waiting' || state === 'Idle') {
    //         return 5.3;
    //     }

    //     // 2. Si el juego ya está corriendo o finalizó, verificamos si es V2
    //     if (matchData && matchData.elapsedMilliseconds !== undefined) {
    //         return 5.2; // Pantalla de Juego V2
    //     }

    //     // 3. Si no cumple lo anterior, nos vamos al juego V1 original
    //     return (state === 'Running' || state === 'Finished') ? 5.1 : 5;
    // }

    // ENRUTADOR ESTRICTO V2 (Ignoramos la V1 para evitar interferencias)
    const routeGoalByState = (state) => {
        // Todo lo que sea espera o inicio, va a la Portada Animada (5.3)
        if (state === 'Waiting' || state === 'Idle') return 5.3;
        // Todo lo demás (Running, Finished) va al Juego V2 (5.2)
        return 5.2;
    }

    const SetGoalAndRoute = (updater) => {
        try {
            setGoal(prev => {
                const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater }
                setActiveComponent(routeGoalByState(next.state, next))
                return next
            })
        } catch (error) { }
    }

    const [goal, setGoal] = useState({
        matchId: null,
        state: 'Waiting',
        progressLucho: 0,
        progressTunita: 0,
        tapsParaGanar: 100,
        winner: null,
        elapsedMilliseconds: 0,
        zonesProgress: []
    })

    const [balloons, setBalloons] = useState({
        matchId: null,
        status: 'Waiting',
        startAt: null,
        endsAt: null,
        target: 0,
        zones: [],
        winners: null
    })

    // ==========================================
    // ESTADO NUEVO: VAS O NO VAS (MALETINES)
    // ==========================================
    const [briefcaseState, setBriefcaseState] = useState({
        phase: 'WAITING',
        briefcases: [], // El backend nos mandará el arreglo de maletines
        suspenseBriefcaseId: null,
        revealData: null
    })

    const RouteBalloonsByStatus = (s, next) => {
        const hasCountdown = next?.startAt && new Date(next.startAt).getTime() > Date.now()
        if (s === 'Running' || s === 'Finished' || hasCountdown) return 10.1
        return 10
    }

    const SetBalloonsAndRoute = (updater) => {
        setBalloons(prev => {
            const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater }
            setActiveComponent(RouteBalloonsByStatus(next.status, next))
            return next
        })
    }

    const forceUIStatus = (status) => {
        setBalloonsUI(prev => {
            const order = { Idle: 0, Countdown: 1, Running: 2, Finished: 3 };
            return order[status] >= order[prev.uiStatus]
                ? { ...prev, uiStatus: status }
                : prev;
        });
    };

    useEffect(() => {
        const connect = async () => {
            await ConnectWebSocketForScreen(setConnectionStatus, showToast)
            SetSocketMessageHandler(handleIncomingMessage)
        }

        const handleIncomingMessage = async (message) => {
            if (!message || !message.type) return

            const response = await GetGenderMode()
            if (response.success) {
                setIsActiveWomensMode(response.data.isWomensModeActive)
            } else {
                setIsActiveWomensMode(false)
            }

            switch (message.type.toLowerCase()) {
                case 'welcome':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(9)
                    break

                case 'wait':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(1)
                    break

                case 'newinstruction':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(2)
                    break

                case 'trivia':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(3)
                    break

                case 'finalresults':
                    setLottery(null); setQuestion(null); setResults(message);
                    setActiveComponent(3.1);
                    break

                case 'loteria':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(4)
                    break

                case 'lotterycard':
                    setLottery(message); setQuestion(null); setResults(null);
                    setActiveComponent(4.1)
                    break

                case 'colores':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(6)
                    break

                case 'setzonecolor':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(6.1)
                    break

                case 'start':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(7)
                    break

                case 'thanks':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(8)
                    break

                // ───────────── RunToGoal (V1 y V2) ─────────────
                // // 1. AGRUPAMOS LOS 3 EVENTOS DE LIMPIEZA AQUÍ:
                // case 'goal':
                // case 'goal.layout':
                // case 'goal.prepare':
                // case 'goal.reset':
                //     SetGoalAndRoute(g => ({
                //         ...g,
                //         state: 'Waiting',
                //         phase: 'Waiting',
                //         elapsedMilliseconds: 0, // CRÍTICO PARA LANZAR LA PORTADA (5.3)
                //         progressLucho: 0,
                //         progressTunita: 0,
                //         winner: null,
                //         zonesProgress: []
                //     }))
                //     break

                // case 'goal.created': {
                //     const cfg = message.payload?.cfg || {}
                //     SetGoalAndRoute({
                //         matchId: message.payload?.matchId ?? null,
                //         state: 'Waiting',
                //         phase: 'Waiting',
                //         elapsedMilliseconds: 0, // CRÍTICO PARA EL RESET V2
                //         totalDurationMilliseconds: (cfg.durationSeconds || 15) * 1000,
                //         progressLucho: 0,
                //         progressTunita: 0,
                //         tapsParaGanar: cfg.tapsParaGanar ?? 100,
                //         winner: null,
                //         zonesProgress: []
                //     })
                //     break
                // }

                // Estos 4 eventos ahora hacen exactamente lo mismo: Limpiar la memoria y mostrar la portada (5.3)
                case 'goal.frontpage':
                case 'goal.layout':
                case 'goal.prepare':
                case 'goal.reset':
                    SetGoalAndRoute(g => ({
                        ...g,
                        matchId: message.payload?.matchId ?? null,
                        state: 'Waiting',
                        phase: 'Waiting',
                        elapsedMilliseconds: 0,
                        progressLucho: 0,
                        progressTunita: 0,
                        tapsParaGanar: 100,
                        winner: null,
                        zonesProgress: []
                    }))
                    break

                case 'goal.created': {
                    const cfg = message.payload?.cfg || {}
                    SetGoalAndRoute({
                        matchId: message.payload?.matchId ?? null,
                        state: 'Waiting',
                        phase: 'Waiting',
                        elapsedMilliseconds: 0,
                        totalDurationMilliseconds: (cfg.durationSeconds || 15) * 1000,
                        progressLucho: 0,
                        progressTunita: 0,
                        tapsParaGanar: cfg.tapsParaGanar ?? 100,
                        winner: null,
                        zonesProgress: []
                    })
                    break
                }

                case 'goal.snapshot': {
                    // const p = message.payload || {}
                    // SetGoalAndRoute({
                    //     ...p,
                    //     matchId: p.matchId ?? null,
                    //     state: p.state ?? 'Waiting',
                    //     phase: p.state ?? 'Waiting',
                    //     progressLucho: p.progressLucho ?? 0,
                    //     progressTunita: p.progressTunita ?? 0,
                    //     tapsParaGanar: p.tapsParaGanar ?? 100,
                    //     winner: p.winner ?? null
                    // })

                    const p = message.payload || {}
                    // Modificamos esto para que use el estado previo (g) y NO borre el elapsedMilliseconds=0
                    SetGoalAndRoute(g => ({
                        ...g,
                        ...p,
                        matchId: p.matchId ?? g.matchId ?? null,
                        state: p.state ?? 'Waiting',
                        phase: p.state ?? 'Waiting',
                        elapsedMilliseconds: p.elapsedMilliseconds !== undefined ? p.elapsedMilliseconds : g.elapsedMilliseconds, // Respeta el 0
                        progressLucho: p.progressLucho ?? g.progressLucho ?? 0,
                        progressTunita: p.progressTunita ?? g.progressTunita ?? 0,
                        tapsParaGanar: p.tapsParaGanar ?? g.tapsParaGanar ?? 100,
                        winner: p.winner ?? g.winner ?? null
                    }))
                    break
                }

                case 'goal.started':
                    SetGoalAndRoute(g => ({
                        ...g,
                        state: 'Running',
                        phase: 'Running',
                        winner: null,
                        progressLucho: 0,
                        progressTunita: 0
                    }))
                    break

                case 'goal.progress': {
                    const p = message.payload || {}
                    if (p.elapsedMilliseconds !== undefined) {
                        // V2
                        SetGoalAndRoute(g => ({ ...g, ...p, state: 'Running', phase: 'Running' }))
                    } else {
                        // V1
                        SetGoalAndRoute(g => ({
                            ...g,
                            state: 'Running',
                            phase: 'Running',
                            progressLucho: p.progressLucho ?? g.progressLucho,
                            progressTunita: p.progressTunita ?? g.progressTunita,
                            tapsParaGanar: p.tapsParaGanar ?? g.tapsParaGanar
                        }))
                    }
                    break
                }

                case 'goal.finished': {
                    const p = message.payload || {}
                    if (p.finalZonesProgress !== undefined) {
                        // V2
                        SetGoalAndRoute(g => ({ ...g, ...p, state: 'Finished', phase: 'Finished', winner: p.winner ?? null }))
                    } else {
                        // V1
                        SetGoalAndRoute(g => ({
                            ...g,
                            state: 'Finished',
                            phase: 'Finished',
                            winner: p.winner ?? null,
                            progressLucho: p.progressLucho ?? g.progressLucho,
                            progressTunita: p.progressTunita ?? g.progressTunita
                        }))
                    }
                    break
                }

                // ───────────── Globos (pantalla) ─────────────
                case 'ballons': {
                    SetBalloonsAndRoute({
                        matchId: null, status: 'Waiting', startAt: null, endsAt: null,
                        target: 0, zones: [], winners: null
                    });
                    break;
                }

                case 'ballonsgame': {
                    SetBalloonsAndRoute(b => ({ ...b, status: 'Waiting' }));
                    break;
                }

                case 'balloon.prepare': {
                    const d = message.data || {}
                    const durationSec = (typeof d.matchDurationSec === 'number' && d.matchDurationSec > 0)
                        ? d.matchDurationSec
                        : ((d.endsAt && d.startAt) ? Math.max(0, Math.floor((Date.parse(d.endsAt) - Date.parse(d.startAt)) / 1000)) : 0)

                    const localCountdownMs = 3000
                    const localStartAt = Date.now() + localCountdownMs
                    const localEndsAt = localStartAt + (durationSec * 1000)

                    SetBalloonsAndRoute(b => ({
                        ...b,
                        matchId: d.matchId ?? d.MatchId ?? b.matchId,
                        status: 'Waiting',
                        startAt: new Date(localStartAt).toISOString(),
                        endsAt: new Date(localEndsAt).toISOString(),
                        target: d.targetTapsPerBalloon ?? d.TargetTapsPerBalloon ?? b.target,
                        winners: null
                    }))
                    break
                }

                case 'balloon.state': {
                    const st = message.data || {}
                    const rawStatus = st.status ?? st.Status
                    const statusNorm = rawStatus === 0 || rawStatus === 'Waiting' ? 'Waiting' :
                        rawStatus === 1 || rawStatus === 'Running' ? 'Running' :
                            rawStatus === 2 || rawStatus === 'Finished' ? 'Finished' : 'Waiting';

                    const matchId = st.matchId ?? st.MatchId ?? null
                    const target = st.targetTapsPerBalloon ?? st.TargetTapsPerBalloon ?? null

                    const zonesIn = st.zones ?? st.Zones;
                    const zonesNorm = Array.isArray(zonesIn)
                        ? zonesIn.map(z => ({
                            zone: (z.zone ?? z.Zone ?? '').toString(),
                            currentBalloonTaps: z.currentBalloonTaps ?? z.CurrentBalloonTaps ?? 0,
                            completedBalloons: z.completedBalloons ?? z.CompletedBalloons ?? 0,
                            totalTaps: z.totalTaps ?? z.TotalTaps ?? 0
                        }))
                        : null

                    SetBalloonsAndRoute(b => ({
                        ...b, matchId: matchId ?? b.matchId, status: statusNorm,
                        startAt: null, endsAt: null, target: target ?? b.target, zones: zonesNorm ?? b.zones
                    }))

                    if (statusNorm === 'Running') forceUIStatus('Running')
                    if (statusNorm === 'Finished') forceUIStatus('Finished')
                    break
                }

                case 'balloon.show-winners': {
                    const d = message.data || {}
                    SetBalloonsAndRoute(b => ({
                        ...b,
                        matchId: d.matchId ?? b.matchId,
                        status: 'Finished',
                        winners: { winnerType: d.winnerType || 'none', winners: d.winners || [], results: d.results || [] }
                    }))
                    forceUIStatus('Finished')
                    break
                }

                case 'balloon.reset': {
                    if (countdownTimerRef.current) { clearTimeout(countdownTimerRef.current); countdownTimerRef.current = null; }
                    SetBalloonsAndRoute({ matchId: null, status: 'Waiting', startAt: null, endsAt: null, target: 0, zones: [], winners: null });
                    setBalloonsUI({ uiStatus: 'Idle', countdownUntil: null });
                    break;
                }

                // ───────────── Adivina Adivinador (Riddle - Tile 10) ─────────────
                case 'riddle':
                case 'riddle_show_cover':
                    setLottery(null); setQuestion(message.data || message.payload || null); setResults(null);
                    setActiveComponent(11);
                    break;

                case 'riddle_show_game':
                case 'newquestionriddler':
                case 'resumequestionriddler':
                case 'riddledisplayitem':
                    setLottery(null); setQuestion(message.data || message.payload); setResults(null);
                    setActiveComponent(11.1);
                    break;

                case 'riddle_change_layout':
                case 'riddle_layout_changed': {
                    const layout = message.screenLayout || message.data?.screenLayout || message.layout || 1;
                    setQuestion(prev => (prev ? { ...prev, screenLayout: layout } : { screenLayout: layout }));
                    break;
                }

                case 'riddle_send_results':
                case 'riddle_final_results':
                    setLottery(null); setQuestion(null); setResults(message);
                    setActiveComponent(3.1);
                    break;

                case 'riddle_reset':
                case 'riddle_reset_results':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(11);
                    break;

                case 'deselectedselfiefan':
                case 'resetselfiefan':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(12)
                    break

                case 'displayselfiefan':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(12.1)
                    break

                case 'selfiefan':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(13)
                    break

                case 'displayselfiefania':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(14)
                    break

                case 'deselectedselfiefania':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(12)
                    break

                case 'quizzwithimageandoptions':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(15)
                    break

                case 'newquestionquizzwithimageandoptions':
                case 'resumequestionquizzwithimageandoptions':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(15.1)
                    break

                case 'frontpagenoisemeter':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(16)
                    break

                case 'noisemeter.prepare':
                case 'noisemeter.finished':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(16.1)
                    break

                case 'frontpagenoisemeterv2':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(32)
                    break

                case 'noisemeterv2.prepare':
                case 'noisemeterv2.finished':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(32.1)
                    break

                case 'qrmessages':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(17)
                    break

                case 'qrpluckingrooster':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(18)
                    break

                case 'rankingpluckingrooster':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(19)
                    break
                
                case 'update_rankingpluckingrooster':
                    setQuestion(message.data);
                    break;

                case 'frontpageluchofest':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(20)
                    break

                case "luchofest.game_running":
                    setLottery(null)
                    setQuestion({ ...message.data, viewType: 'playing' })
                    setResults(null)
                    setActiveComponent(20.1)
                    break

                case "luchofest.show_winner":
                    setLottery(null)
                    setQuestion({ ...message.data, viewType: 'winner' })
                    setResults(null)
                    setActiveComponent(20.1)
                    break

                case "luchofest.show_practice_finished":
                    setLottery(null)
                    setQuestion({ ...message.data, viewType: 'practice' })
                    setResults(null)
                    setActiveComponent(20.1)
                    break

                case "luchofest.stop":
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(20)
                    break

                case 'picnic.layout':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(21)
                    break

                case 'picnic.finished':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(21.1)
                    break

                // ==========================================
                // DINÁMICA: VAS O NO VAS (MALETINES)
                // ==========================================
                case 'briefcase.layout':
                    // Limpiamos basura de otros juegos
                    setLottery(null); setQuestion(null); setResults(null);
                    // Seteamos una vista previa por defecto (9 maletines cerrados) en lo que arranca
                    setBriefcaseState({
                        phase: 'WAITING',
                        briefcases: Array.from({ length: 9 }, (_, i) => ({ id: i + 1, state: 'closed', prizeTheme: 'none' })),
                        suspenseBriefcaseId: null,
                        revealData: null
                    });
                    setActiveComponent(22);
                    break;

                case 'briefcase.update':
                    // El backend nos mandará el estado completo del juego cada que el Admin abra un maletín
                    if (message.payload) {
                        setBriefcaseState(message.payload);
                        setActiveComponent(22.1);
                    }
                    break;

                // ==========================================
                // DINÁMICA: RETO TAQUERO 1 VS 1
                // ==========================================
                case 'taco.layout':
                case 'taco.reset':
                    setLottery(null); setQuestion(null); setResults(null);
                    setTacoMatchState(null); // Limpiamos para volver a la configuración base
                    setActiveComponent(23.1); 
                    break;

                case 'taco.progress':
                case 'taco.finished':
                    if (message.payload) {
                        setTacoMatchState(message.payload);
                        setActiveComponent(23.1);
                    }
                    break;

                case 'taco.frontpage':
                    setLottery(null); setQuestion(null); setResults(null);
                    setTacoMatchState(null);
                    setActiveComponent(23); 
                    break;

                case 'catchtheball':
                    setCatchMatchState(message.data); // data trae action y payload
                    setActiveComponent(24); // Usamos el ID 24 para esta dinámica
                    break;

                // ───────────── Tragamonedas ─────────────
                case 'slotmachine.enter':
                case 'slotmachine.prepare':
                case 'slotmachine.spin':
                case 'slotmachine.toggleqr':
                case 'slotmachine.togglethanks':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    
                    // Guardamos el mensaje completo para pasárselo a la máquina
                    setSlotPayload(message);
                    
                    // Aseguramos que el componente 25 esté en pantalla
                    setActiveComponent(25);
                    break;

                case 'roulette.prepare':
                case 'roulette.spin':
                case 'roulette.toggleqr':
                case 'roulette.togglethanks':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setRoulettePayload(message);
                    setActiveComponent(28);
                    break;

                case 'voting.start':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(26); // Usaremos el 30 para la votación en pantalla
                    break;
                case 'voting.results':
                    setLottery(null); setQuestion(null); setResults(message.data);
                    setActiveComponent(26.1); 
                    break;

                case 'sequence.frontpage':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(29);
                    break;

                case 'sequence.layout':
                case 'sequence.update':
                case 'sequence.reset':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setSequencePayload(message);
                    setActiveComponent(29.1);
                    break;

                case 'rollers.cover':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setActiveComponent(36);
                    break;

                case 'rollers.prepare':
                case 'rollers.spin':
                case 'rollers.thanks':
                case 'rollers.stop_reel':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setRollersPayload(message);
                    setActiveComponent(36.1);
                    break;

                case 'dinosaur.cover':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setDinosaurPayload(message);
                    setActiveComponent(37);
                    break;
                    
                case 'dinosaur.prepare':
                case 'dinosaur.start':
                case 'dinosaur.jump':
                case 'dinosaur.gameover':
                case 'dinosaur.reset':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setDinosaurPayload(message);
                    setActiveComponent(37.1);
                    break;

                case 'aura.cover':
                case 'aura_show_cover':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setAuraPayload(message);
                    setActiveComponent(39);
                    break;

                case 'aura.prepare':
                case 'aura_show_game':
                case 'aura_countdown':
                case 'aura_round_started':
                case 'aura_telemetry':
                case 'aura_paused':
                case 'aura_resumed':
                case 'aura_game_over':
                case 'aura_reset':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setAuraPayload(message);
                    setActiveComponent(39.1);
                    break;

                case 'buzzer.cover':
                case 'buzzer_show_cover':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setBuzzerPayload(message);
                    setActiveComponent(40);
                    break;

                case 'buzzer.prepare':
                case 'buzzer_show_game':
                case 'buzzer_match_initialized':
                case 'buzzer_question_intro':
                case 'buzzer_question_launched':
                case 'buzzer_options_shown':
                case 'buzzer_turn_assigned':
                case 'buzzer_option_selected':
                case 'buzzer_option_cleared':
                case 'buzzer_result_revealed':
                case 'buzzer_force_updated':
                case 'buzzer_rebound':
                case 'buzzer_rebound_granted':
                case 'buzzer_final_podium':
                case 'buzzer_game_over':
                case 'buzzer_final_results':
                case 'buzzer_match_reset':
                case 'buzzer_reset':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setBuzzerPayload(message);
                    setActiveComponent(40.1);
                    break;

                case 'buzzer_snapshot':
                case 'buzzer_state': {
                    const snapData = message.state || message.data || message.payload;
                    if (snapData && snapData.state && snapData.state !== 'idle' && (snapData.themeId > 0 || snapData.currentTheme)) {
                        setLottery(null);
                        setQuestion(null);
                        setResults(null);
                        setBuzzerPayload(message);
                        if (snapData.state === 'cover') {
                            setActiveComponent(40);
                        } else {
                            setActiveComponent(40.1);
                        }
                    }
                    break;
                }

                // ==========================================
                // DINÁMICA: RASCA Y GANA (TILE 43)
                // ==========================================
                case 'scratcher.cover':
                case 'scratcher_show_cover':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setScratcherPayload(message);
                    setActiveComponent(43);
                    break;

                case 'scratcher.prepare':
                case 'scratcher_show_game':
                case 'scratcher_countdown':
                case 'scratcher_round_started':
                case 'scratcher_game_started':
                case 'scratcher_progress_sync':
                case 'scratcher_game_over':
                case 'scratcher_game_finished':
                case 'scratcher_paused':
                case 'scratcher_resumed':
                case 'scratcher_telemetry':
                case 'scratcher_update_names':
                case 'scratcher_set_player_names':
                case 'scratcher_players_updated':
                case 'scratcher_reset':
                case 'scratcher_match_reset':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setScratcherPayload(message);
                    setActiveComponent(43.1);
                    break;

                case 'scratcher_snapshot':
                case 'scratcher_state': {
                    const snapData = message.state || message.data || message.payload;
                    if (snapData && snapData.state && snapData.state !== 'idle' && (snapData.themeId > 0 || snapData.activeThemeId > 0 || snapData.currentTheme || snapData.activeTheme)) {
                        setLottery(null);
                        setQuestion(null);
                        setResults(null);
                        setScratcherPayload(message);
                        if (snapData.state === 'cover') {
                            setActiveComponent(43);
                        } else {
                            setActiveComponent(43.1);
                        }
                    }
                    break;
                }

                // ==========================================
                // DINÁMICA: REACCIÓN RÁPIDA 1 VS 1 (TILE 44)
                // ==========================================
                case 'quick_reaction.cover':
                case 'quick_reaction_show_cover':
                case 'reaccion_show_cover':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setQuickReactionPayload(message);
                    setActiveComponent(44);
                    break;

                case 'quick_reaction.game':
                case 'quick_reaction_show_game':
                case 'reaccion_show_game':
                case 'quick_reaction_countdown_tick':
                case 'quick_reaction_countdown':
                case 'quick_reaction.countdown':
                case 'quick_reaction_random_wait':
                case 'quick_reaction.random_wait':
                case 'quick_reaction_trigger_active':
                case 'quick_reaction.trigger_active':
                case 'quick_reaction_early_fault':
                case 'quick_reaction.early_fault':
                case 'quick_reaction_match_finished':
                case 'quick_reaction.match_finished':
                case 'quick_reaction_update_names':
                case 'quick_reaction_player_joined':
                case 'quick_reaction_player_left':
                case 'quick_reaction_reset':
                case 'quick_reaction.reset':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setQuickReactionPayload(message);
                    setActiveComponent(44.1);
                    break;

                case 'quick_reaction_snapshot':
                case 'quick_reaction_state': {
                    const snapData = message.state || message.data || message.payload;
                    if (snapData && snapData.state && snapData.state !== 'idle') {
                        setLottery(null);
                        setQuestion(null);
                        setResults(null);
                        setQuickReactionPayload(message);
                        if (snapData.state === 'cover') {
                            setActiveComponent(44);
                        } else {
                            setActiveComponent(44.1);
                        }
                    }
                    break;
                }

                // ==========================================
                // DINÁMICA: ARMA LA PLAYLIST (TILE 46)
                // ==========================================
                case 'playlist.project':
                case 'playlist.prepare':
                case 'playlist.cover':
                case 'playlist.screen':
                case 'playlist.show':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setPlaylistPayload(message);
                    setActiveComponent(46);
                    break;

                case 'playlist':
                case 'playlist.now_playing':
                case 'playlist.queue':
                case 'playlist.state':
                case 'playlist.settings':
                    setPlaylistPayload(message);
                    break;

                // ==========================================
                // DINÁMICA: ESTIRA Y AFLOJA (TUGOFWAR - TILE 47)
                // ==========================================
                case 'tugofwar.cover':
                case 'tugofwar_show_cover':
                case 'tugofwar_cover_shown':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setTugOfWarPayload(message);
                    setActiveComponent(47);
                    break;

                case 'tugofwar.prepare':
                case 'tugofwar_show_game':
                case 'tugofwar_game_scene_shown':
                case 'tugofwar_countdown':
                case 'tugofwar_countdown_tick':
                case 'tugofwar_round_started':
                case 'tugofwar_match_started':
                case 'tugofwar_telemetry':
                case 'tugofwar_sudden_death_started':
                case 'tugofwar_game_over':
                case 'tugofwar_paused':
                case 'tugofwar_resumed':
                case 'tugofwar_reset':
                case 'tugofwar_match_reset':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setTugOfWarPayload(message);
                    setActiveComponent(47.1);
                    break;

                case 'tugofwar_snapshot':
                case 'tugofwar_state': {
                    const snapData = message.state || message.data || message.payload;
                    if (snapData && snapData.state && snapData.state !== 'idle') {
                        setLottery(null);
                        setQuestion(null);
                        setResults(null);
                        setTugOfWarPayload(message);
                        if (snapData.state === 'cover') {
                            setActiveComponent(47);
                        } else {
                            setActiveComponent(47.1);
                        }
                    }
                    break;
                }

                // ==========================================
                // DINÁMICA: MEMORAMA / MEMORY (TILE 48)
                // ==========================================
                case 'memory.cover':
                case 'memory_cover':
                case 'memory_show_cover':
                case 'memory_cover_shown':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setMemoryPayload(message);
                    setActiveComponent(48);
                    break;

                case 'memory.prepare':
                case 'memory_game_ready':
                case 'memory_game_shown':
                case 'memory_show_game':
                case 'memory_game_scene_shown':
                case 'memory_countdown_tick':
                case 'memory_countdown':
                case 'memory_countdown_started':
                case 'memory_preview_start':
                case 'memory_preview':
                case 'memory_preview_end':
                case 'memory_preview_ended':
                case 'memory_playing_started':
                case 'memory_start':
                case 'memory_game_start':
                case 'memory_card_flipped':
                case 'memory_match_success':
                case 'match_success':
                case 'memory_match_failed':
                case 'match_failed':
                case 'memory_cards_unflipped':
                case 'cards_unflipped':
                case 'memory_all_pairs_matched':
                case 'all_pairs_matched':
                case 'memory_telemetry':
                case 'memory_names_updated':
                case 'memory_update_names':
                case 'memory_finished':
                case 'memory_game_finish':
                case 'memory_game_finished':
                case 'memory_game_over':
                case 'memory_game_reset':
                case 'memory_match_reset':
                case 'memory_score_adjusted':
                case 'memory_player_joined':
                case 'memory_player_left':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setMemoryPayload(message);
                    setActiveComponent(48.1);
                    break;

                case 'memory_snapshot':
                case 'memory_state_sync':
                case 'memory_sync_state':
                case 'memory_state': {
                    const snapData = message.state || message.data || message.payload;
                    if (snapData && (snapData.state || snapData.phase) && (snapData.state !== 'idle' && snapData.phase !== 'idle')) {
                        setLottery(null);
                        setQuestion(null);
                        setResults(null);
                        setMemoryPayload(message);
                        const phase = String(snapData.phase || snapData.state || '').toLowerCase();
                        if (phase === 'cover') {
                            setActiveComponent(48);
                        } else {
                            setActiveComponent(48.1);
                        }
                    }
                    break;
                }

                // ==========================================
                // DINÁMICA: OPTIMO ÓPTICAS (TILE 49)
                // ==========================================
                case 'optimoopticas.cover':
                case 'optimoopticas_cover':
                case 'optimoopticas_show_cover':
                case 'optimoopticas_cover_shown':
                case 'optimoopticas':
                case 'optimo_opticas':
                case 'optimo_opticas.cover':
                case 'psl_optopticas.cover':
                case 'psl_optopticas':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setOptimoOpticasPayload(message);
                    setActiveComponent(49);
                    break;

                // ==========================================
                // DINÁMICA: CRONÓMETRO (TILE 50)
                // ==========================================
                case 'crono_show_cover':
                case 'crono_cover':
                case 'cronometer.cover':
                case 'cronometer_cover':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setCronometerPayload(message);
                    setActiveComponent(50);
                    break;

                case 'crono_show_game':
                case 'crono_game':
                case 'cronometer.game':
                case 'cronometer_game':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setCronometerPayload(message);
                    setActiveComponent(50.1);
                    break;

                case 'crono_screen_mode': {
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setCronometerPayload(message);
                    const mode = (message.mode || message.payload?.mode || message.data?.mode || '').toLowerCase();
                    if (mode === 'cover') {
                        setActiveComponent(50);
                    } else {
                        setActiveComponent(50.1);
                    }
                    break;
                }

                case 'crono_show_objective':
                case 'crono_start_phase':
                case 'crono_objective_expired':
                case 'crono_end_phase':
                case 'crono_update_spectator':
                case 'crono_reset_game':
                case 'crono_reset':
                case 'crono_change_phase':
                case 'crono_game_state':
                    setCronometerPayload(message);
                    // No forzar la pantalla si no está proyectando Cronómetro actualmente
                    setActiveComponent(prev => (prev === 50 || prev === 50.1 ? prev : prev));
                    break;

                // ==========================================
                // DINÁMICA: MEMORAMA INDIVIDUAL (TILE 51)
                // ==========================================
                case 'memoryindividual.cover':
                case 'memoryindividual_cover':
                case 'memoryindividual_show_cover':
                case 'memoryindividual':
                case 'psl_memory.cover':
                case 'psl_memory':
                case 'memory_individual.cover':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    setMemoryIndividualPayload(message);
                    setActiveComponent(51);
                    break;

                default:


                    console.log('Unknown:', message.type)
                    break
            }
        }

        connect()
        document.body.classList.add('customBg')

        return () => {
            ClearSocketMessageHandler()
            DisconnectWebSocket()
            if (countdownTimerRef.current) clearTimeout(countdownTimerRef.current);
        }
    }, [])

    return (
        <>
            {activeComponent === 1 && (<Wait isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 2 && (<Questions question={question} />)}
            {activeComponent === 3 && (<Wait isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 3.1 && (<Results payload={results} />)}
            {activeComponent === 4 && (<Wait isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 4.1 && (<Lottery payload={lottery} />)}
            {/* {activeComponent === 5 && (<Versus isActiveWomensMode={isActiveWomensMode} />)} */}
            {/* {activeComponent === 5.1 && (<GoalScreen state={goal} />)} */}
            {activeComponent === 5.2 && (<GoalScreenV2 currentMatchState={goal} />)}
            {activeComponent === 5.3 && (<FrontPageRunToGoal isActiveWomensMode={isActiveWomensMode} />)}
            {/* {activeComponent === 5.3 && (<FrontPageRunToGoalDaikin />)} */}
            {/* {activeComponent === 5.3 && (<FrontPageRunToGoal />)} Para La Moderna */}
            {/* {activeComponent === 5.2 && (<GoalScreenV2_Caminadora currentMatchState={goal} />)} */}
            {activeComponent === 6 && (<Colors />)}
            {activeComponent === 6.1 && (<Colors />)}
            {activeComponent === 7 && (<Start isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 8 && (<Thanks isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 9 && (<Welcome isActiveWomensMode={isActiveWomensMode} />)}

            {/* {activeComponent === 10 && (<RojitoBrandFrontPage isActiveWomensMode={isActiveWomensMode} />)} */}
            {/* {activeComponent === 10 && (<RojitoBrandFrontPage isActiveWomensMode={isActiveWomensMode} />)} */}
            {activeComponent === 10 && (<BalloonsFrontPage isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 10.1 && (<Balloons state={balloons} ui={balloonsUI} isActiveWomensMode={isActiveWomensMode} />)}

            {activeComponent === 11 && (<RiddleCover data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 11.1 && (<Riddle riddle={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 11.2 && (<Results payload={results} />)}
            {activeComponent === 12 && (<Start isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 12.1 && (<SelfieFan selfieFan={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 13 && (<QRSelfieFan data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 14 && (<SelfieFanIA selfieFan={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 15 && (<FrontPage data={question} />)}
            {activeComponent === 15.1 && (<QuizzWithImageAndOptions quizz={question} />)}
            {activeComponent === 16 && (<FrontPageNoisemeter isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 16.1 && (<Noisemeter data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 32 && (<FrontPageNoisemeterV2 isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 32.1 && (<NoisemeterV2 data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 17 && (<QRMessages data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 18 && (<QRPluckingRooster data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 19 && (<RankingPluckingRooster data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 20 && (<FrontPageLuchoFest isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 20.1 && (<LuchoFest question={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 21 && (<FrontPagePicnic isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 21.1 && (<Picnic matchResults={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 22 && (<FrontPageBriefcase />)}
            {activeComponent === 22.1 && (<BriefcaseScreen currentGameState={briefcaseState} />)}
            {/* Para dinámica de Tacos */}
            {/* {activeComponent === 23 && (<FrontPageTacos />)}
            {activeComponent === 23.1 && (<Tacos currentGameState={tacoMatchState} />)} */}
            {/* Para dinámica de De regreso al Barrio 9 */}
            {activeComponent === 23 && (<FrontPagePackage />)}
            {activeComponent === 23.1 && (<Package currentGameState={tacoMatchState} />)}
            {activeComponent === 24 && (<CatchTheBall incomingData={catchMatchState} />)}
            {activeComponent === 25 && ( <SlotMachine screenId={1} isStandalone={false} payload={slotPayload} /> )}
            {activeComponent === 26 && (<Voting payload={question} results={null} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 26.1 && (<Voting payload={null} results={results} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 28 && (<Roulette screenId={1} isStandalone={false} payload={roulettePayload} />)}
            {activeComponent === 29 && (<FrontPageSequence />)}
            {activeComponent === 29.1 && (<SequenceScreen screenId={1} isStandalone={false} payload={sequencePayload} />)}
            {activeComponent === 36 && (<FrontPageRollers />)}
            {activeComponent === 36.1 && (<RollersScreen screenId={1} isStandalone={false} payload={rollersPayload} />)}
            {activeComponent === 37 && (<DinosaurFrontPage theme={dinosaurPayload?.data?.theme || dinosaurPayload?.payload?.theme} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 37.1 && (<DinosaurScreen screenId={1} isStandalone={false} payload={dinosaurPayload} />)}
            {activeComponent === 39 && (<FarmeandoAuraCover payload={auraPayload} />)}
            {activeComponent === 39.1 && (<FarmeandoAuraGame payload={auraPayload} />)}
            {activeComponent === 40 && (<BuzzerBattleCover payload={buzzerPayload} />)}
            {activeComponent === 40.1 && (<BuzzerBattleGame payload={buzzerPayload} />)}
            {activeComponent === 43 && (<ScratcherCover payload={scratcherPayload} />)}
            {activeComponent === 43.1 && (<ScratcherGame payload={scratcherPayload} />)}
            {activeComponent === 44 && (<QuickReactionCover payload={quickReactionPayload} />)}
            {activeComponent === 44.1 && (<QuickReactionGame payload={quickReactionPayload} />)}
            {activeComponent === 46 && (<PlaylistScreen payload={playlistPayload} />)}
            {activeComponent === 47 && (<TugOfWarCover payload={tugOfWarPayload} />)}
            {activeComponent === 47.1 && (<TugOfWarGame payload={tugOfWarPayload} />)}
            {activeComponent === 48 && (<MemoryCover payload={memoryPayload} />)}
            {activeComponent === 48.1 && (<MemoryGame payload={memoryPayload} />)}
            {activeComponent === 49 && (<OptimoOpticasCover payload={optimoOpticasPayload} />)}
            {activeComponent === 50 && (<CronometerCover payload={cronometerPayload} />)}
            {activeComponent === 50.1 && (<CronometerGame payload={cronometerPayload} />)}
            {activeComponent === 51 && (<QRMemoryIndividual payload={memoryIndividualPayload} isActiveWomensMode={isActiveWomensMode} />)}
            {!activeComponent && (<Start isActiveWomensMode={isActiveWomensMode} />)}


            
            {toastMessage && (
                <div className="toast-container position-fixed bottom-0 start-50 translate-middle-x mb-3">
                    <div className="toast show bg-success text-white px-3 py-2 shadow rounded">
                        {toastMessage}
                    </div>
                </div>
            )}
        </>
    )
}

export { Screen };